import Vue from 'vue';
import FuncModal from '@/components/FuncModal.vue';

class Nav {
  private instance: Vue | null = null;

  open(options = {}) {
    if (this.instance) {
      console.warn('Modal is already open.');
      return;
    }

    const Instance = new Vue({
      render: (h) => h(FuncModal, { props: options }),
    });
    const component = Instance.$mount();
    document.body.appendChild(component.$el);
    this.instance = Instance;
  }

  close() {
    if (!this.instance) {
      return;
    }

    const component = this.instance.$children[0];
    document.body.removeChild(this.instance.$el);
    this.instance.$destroy();
    this.instance = null;

    if (component && typeof (component as any).onClose === 'function') {
      (component as any).onClose();
    }
  }

  isOpen(): boolean {
    return this.instance !== null;
  }
}

export const navComponent = new Nav();
